module.exports = __webpack_public_path__ + "static/img/85-1.ca56cb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/85-1.jpg
// module id = CJ1e
// module chunks = 0